require("prismjs/themes/prism-okaidia.css")
require("./src/styles/global.css")
const React = require("react")
//const { useState, useEffect } = require('react')
//const Cookies = require("js-cookie")
const { DarkModeProvider } = require("./src/context/DarkModeContext")
//const { CookiesProvider } = require('react-cookie')


exports.wrapRootElement = ({ element }) => {
  //const initialValue = Cookies.get("darkMode") === "on"
  const isDarkMode = localStorage.getItem('theme')
  const isDark = document.documentElement.classList.contains('dark')
  console.log('browser localStorage: ', isDarkMode)
  console.log('document: ', isDark)

  return <DarkModeProvider initialValue={undefined}>{element}</DarkModeProvider>
}
